"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _parseFloat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/parse-float"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var _angieslistStyles = require("angieslist-styles");
require("./ratingSelection.scss");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ratings = [{
  ratingValue: 1.0,
  description: 'Lousy'
}, {
  ratingValue: 2.0,
  description: 'Bad'
}, {
  ratingValue: 3.0,
  description: 'Fair'
}, {
  ratingValue: 4.0,
  description: 'Good'
}, {
  ratingValue: 5.0,
  description: 'Excellent'
}];
var RatingSelection = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RatingSelection, _React$Component);
  var _super = _createSuper(RatingSelection);
  function RatingSelection(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RatingSelection);
    _this = _super.call(this, props);
    var initialStar = (0, _find["default"])(ratings).call(ratings, function (rating) {
      return rating.ratingValue === props.existingRatingValue;
    });
    _this.state = {
      filledInStarValues: (0, _filter["default"])(ratings).call(ratings, function (rating) {
        return rating.ratingValue <= props.existingRatingValue;
      }),
      hoveredStarValues: [],
      noRatingBold: false,
      numericalStarValue: initialStar ? initialStar.ratingValue : undefined,
      previousSelectedStarValue: {},
      previousStarValues: [],
      selectedNoRating: false,
      selectedStarValue: initialStar
    };
    return _this;
  }
  (0, _createClass2["default"])(RatingSelection, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        allowNoRating = _this$props.allowNoRating,
        customClass = _this$props.customClass,
        customId = _this$props.customId,
        noRatingFontSize = _this$props.noRatingFontSize,
        ratingDescription = _this$props.ratingDescription,
        ratingFontSize = _this$props.ratingFontSize,
        ratingSelectionCallBackFunction = _this$props.ratingSelectionCallBackFunction,
        starSize = _this$props.starSize;
      var _this$state = this.state,
        filledInStarValues = _this$state.filledInStarValues,
        hoveredStarValues = _this$state.hoveredStarValues,
        noRatingBold = _this$state.noRatingBold,
        numericalStarValue = _this$state.numericalStarValue,
        previousSelectedStarValue = _this$state.previousSelectedStarValue,
        previousStarValues = _this$state.previousStarValues,
        selectedNoRating = _this$state.selectedNoRating,
        selectedStarValue = _this$state.selectedStarValue;
      var noRatingFontSizeInternal = noRatingFontSize || '0.75em';
      var starSizeInternal = starSize || '2em';
      var setRatingsForFullStars = function setRatingsForFullStars(currentRating) {
        return (0, _filter["default"])(ratings).call(ratings, function (rating) {
          return rating.ratingValue <= currentRating.ratingValue;
        });
      };
      var showFullStar = function showFullStar(ratingValue) {
        return (0, _find["default"])(hoveredStarValues).call(hoveredStarValues, function (rating) {
          return rating.ratingValue === ratingValue;
        }) || (0, _find["default"])(filledInStarValues).call(filledInStarValues, function (rating) {
          return rating.ratingValue === ratingValue;
        });
      };
      var setStarSelection = function setStarSelection(starWasClicked, currentRating) {
        var newStarSelections = setRatingsForFullStars(currentRating);
        if (starWasClicked) {
          _this2.setState({
            filledInStarValues: newStarSelections,
            selectedStarValue: currentRating,
            hoveredStarValues: [],
            noRatingBold: false,
            selectedNoRating: false,
            numericalStarValue: currentRating.ratingValue
          });
        } else {
          _this2.setState({
            hoveredStarValues: newStarSelections,
            noRatingBold: false,
            filledInStarValues: [],
            numericalStarValue: currentRating.ratingValue
          });
        }
      };
      var setNoRatingSelection = function setNoRatingSelection(noRatingClicked) {
        if (noRatingClicked) {
          _this2.setState({
            previousStarValues: [],
            previousSelectedStarValue: {},
            filledInStarValues: [],
            selectedStarValue: {},
            hoveredStarValues: [],
            noRatingBold: true,
            selectedNoRating: true
          });
        } else {
          _this2.setState({
            previousStarValues: filledInStarValues,
            previousSelectedStarValue: selectedStarValue,
            filledInStarValues: [],
            hoveredStarValues: [],
            noRatingBold: true
          });
        }
      };
      var noRatingStyling = noRatingBold ? _angieslistStyles.stylesColors.iconDark : _angieslistStyles.stylesColors.iconLight;
      var returnToPreviousStarValues = selectedStarValue && selectedStarValue.ratingValue ? (0, _filter["default"])(ratings).call(ratings, function (rating) {
        return rating.ratingValue <= selectedStarValue.ratingValue;
      }) : [];
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: customId,
        className: customClass
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "rating-selection-wrapper",
        onMouseLeave: function onMouseLeave() {
          _this2.setState({
            filledInStarValues: returnToPreviousStarValues,
            hoveredStarValues: [],
            numericalStarValue: selectedStarValue ? selectedStarValue.ratingValue : undefined
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, ratingDescription, selectedStarValue && !selectedNoRating ? /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: _angieslistStyles.stylesColors.brandPrimary,
          paddingLeft: '10px'
        }
      }, "You rated: ".concat(selectedStarValue.description)) : null), /*#__PURE__*/_react["default"].createElement("div", {
        id: "rating-selection-".concat(ratingDescription)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        id: "rating-selection-".concat(ratingDescription, "-ratings"),
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            noRatingBold: selectedNoRating
          });
        }
      }, (0, _map["default"])(ratings).call(ratings, function (rating) {
        var _context;
        var ratingId = (0, _concat["default"])(_context = "reviews--rating-".concat(ratingDescription, "--")).call(_context, rating.ratingValue);
        return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Button, {
          id: ratingId,
          key: ratingId,
          bsStyle: "link",
          onClick: function onClick() {
            setStarSelection(true, rating);
            ratingSelectionCallBackFunction(rating);
          },
          onMouseEnter: function onMouseEnter() {
            return setStarSelection(false, rating);
          }
        }, showFullStar(rating.ratingValue, hoveredStarValues, filledInStarValues) ? /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.FullStar, {
          key: "full-star-".concat(rating.ratingValue),
          size: starSizeInternal
        }) : /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.EmptyStar, {
          key: "empty-star-".concat(rating.ratingValue),
          size: starSizeInternal
        }));
      })), allowNoRating ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "rating-na-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Button, {
        style: {
          fontSize: noRatingFontSizeInternal,
          color: noRatingStyling,
          borderColor: noRatingStyling
        },
        className: "rating-na-button",
        id: "reviews--rating-".concat(ratingDescription, "--N/A"),
        onClick: function onClick() {
          setNoRatingSelection(true);
          ratingSelectionCallBackFunction({
            ratingDescription: 'N/A',
            ratingValue: -1
          });
        },
        onMouseEnter: function onMouseEnter() {
          return setNoRatingSelection(false);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            noRatingBold: selectedNoRating,
            filledInStarValues: previousStarValues,
            selectedStarValue: previousSelectedStarValue
          });
        }
      }, "N/A")) : numericalStarValue ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "rating-number",
        style: {
          fontSize: ratingFontSize
        }
      }, (0, _parseFloat["default"])(numericalStarValue.toFixed(1)).toFixed(1)) : null)));
    }
  }]);
  return RatingSelection;
}(_react["default"].Component);
RatingSelection.propTypes = {
  allowNoRating: _propTypes["default"].bool,
  customClass: _propTypes["default"].string,
  customId: _propTypes["default"].string,
  existingRatingValue: _propTypes["default"].number,
  noRatingFontSize: _propTypes["default"].string,
  ratingDescription: _propTypes["default"].string,
  ratingFontSize: _propTypes["default"].string,
  ratingSelectionCallBackFunction: _propTypes["default"].func,
  starSize: _propTypes["default"].string
};
RatingSelection.defaultProps = {
  allowNoRating: false,
  existingRatingValue: undefined,
  customClass: '',
  customId: 'Rating-Selection',
  noRatingFontSize: '0.70em',
  ratingFontSize: '1.2em',
  ratingDescription: 'Overall',
  ratingSelectionCallBackFunction: function ratingSelectionCallBackFunction() {},
  starSize: '2em'
};
var _default = exports["default"] = RatingSelection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/ratings/ratingSelection.js
// module id = 6267
// module chunks = 25